import React, { Component } from 'react';

import { withDeleteReport } from './../../../shared/containers/containerDeleteReport'

import SnackbarWrapper from './../../../shared/items/static/snackbarWrapper'
import Notification from '../../../shared/items/static/notification'

import { states } from './../../../reducers/queriesStates'

class DeleteSavedReportNotification extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleteNotificateOpen: false,
    }
  }

  componentDidMount() {
    if (this.state.deleteNotificateOpen !== false)
      this.setState({ deleteNotificateOpen: false })
  }

  componentDidUpdate(prevProps) {
    const { deleteReportDataState } = this.props

    if (deleteReportDataState === states.READY && prevProps.deleteReportDataState === states.REQUEST) {
      if (this.state.deleteNotificateOpen !== true)
        this.setState({ deleteNotificateOpen: true })
    }

    if (deleteReportDataState === states.FAILURE && prevProps.deleteReportDataState === states.REQUEST) {
      if (this.state.deleteNotificateOpen !== true)
        this.setState({ deleteNotificateOpen: true })
    }
  }

  closeNotification() {
    this.setState({ deleteNotificateOpen: false })
  }

  render() {
    const { deleteReportDataState } = this.props

    return (
      deleteReportDataState === states.READY
        ? <SnackbarWrapper
          isOpen={!!this.state.deleteNotificateOpen}
          timer={5000}
          isClose={this.closeNotification.bind(this)}
        >
          <Notification type="success">
            <p>{`Отчет успешно удален`}</p>
          </Notification>
        </SnackbarWrapper>
        : deleteReportDataState === states.FAILURE
          ? <SnackbarWrapper
            isOpen={!!this.state.deleteNotificateOpen}
            timer={5000}
            isClose={this.closeNotification.bind(this)}
          >
            <Notification type="error">
              <p>{`Ошибка удаления отчета, повторите позже`}</p>
            </Notification>
          </SnackbarWrapper>
          : null
    )
  }
}

export default withDeleteReport(DeleteSavedReportNotification)